module.exports = __webpack_public_path__ + "static/bg_exp-1293c3282490ac51cb809dd8c7c8a3ba.svg";